/// <amd-module name="VSSUI/Pill" />
export { Pill } from "./Components/Pill/Pill";
export { IPillProps, PillSize, PillVariant } from "./Components/Pill/Pill.Props";
